import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { TrustStrip } from "./components/TrustStrip";
import { Services } from "./components/Services";
import { PromoInspection } from "./components/PromoInspection";
import { ProblemSolver } from "./components/ProblemSolver";
import { UsedCar } from "./components/UsedCar";
import { WhyUs } from "./components/WhyUs";
import { About } from "./components/About";
import { Gallery } from "./components/Gallery";
import { Reviews } from "./components/Reviews";
import { AppointmentForm } from "./components/AppointmentForm";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import ServicesPage from "./pages/ServicesPage";
import { scrollToId } from "./config/business";

const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const t = setTimeout(() => scrollToId(id), 150);
      return () => clearTimeout(t);
    }
  }, [location.state]);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <PromoInspection />
        <ProblemSolver />
        <UsedCar />
        <WhyUs />
        <About />
        <Gallery />
        <Reviews />
        <AppointmentForm />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
